export const DELIVERY_STATES = [
  "pending",
  "sent",
  "delivered",
  "read",
  "failed",
] as const;
export type DeliveryState = (typeof DELIVERY_STATES)[number];

/** Accept both channel DTOs and local upload entries without inventing receipts. */
export interface DeliverySource {
  status?: string | null;
  failed?: string | boolean;
  queued?: boolean;
  uploading?: number;
}

export function messageDelivery(source: DeliverySource): DeliveryState {
  if (source.failed || source.status === "failed") return "failed";
  if (source.uploading !== undefined || source.queued) return "pending";
  switch (source.status) {
    case "sent":
    case "delivered":
    case "read":
      return source.status;
    default:
      return "pending";
  }
}

/** An album is only delivered/read when every item has that receipt. */
export function albumDelivery(
  messages: readonly DeliverySource[],
): DeliveryState {
  const states = messages.map(messageDelivery);
  if (states.includes("failed")) return "failed";
  if (!states.length || states.includes("pending")) return "pending";
  if (states.includes("sent")) return "sent";
  if (states.includes("delivered")) return "delivered";
  return "read";
}
